import * as Yup from 'yup';
import {
  CancelElectricScooterFormValues,
  CancelReasonElectricScooter,
} from './cancelElectricScooterForm.types';

export const getElectricScooterCancellationValidationSchema =
  (): Yup.ObjectSchema<CancelElectricScooterFormValues> => {
    return Yup.object()
      .shape({
        cancelReason: Yup.mixed<CancelReasonElectricScooter>().required(),
      })
      .defined();
  };
